import React from "react";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button } from "@proda-ai/ui-kit";
import type { CustomCellRendererProps } from "@/ui/molecules/Grid";
import type { AddExtractionRow } from "../dealTypes";

import { isNotUndefinedTypeGuard } from "@/utils/guards";

type CreateExtractionRendererProps =
    CustomCellRendererProps<AddExtractionRow> & {
        numOfExtractions: number;
        handleAddExtractionButtonClicked: (params: {
            projectId: number;
            databaseId: number;
            fileId: number;
            fileName: string;
        }) => void;
    };

export const CreateExtractionRenderer: React.FC<
    CreateExtractionRendererProps
> = ({ node, handleAddExtractionButtonClicked }) => {
    const data = node.data;
    return (
        <Box
            sx={{
                ml: "3rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                gap: "2rem",
                height: "100%",
                alignItems: "center",
            }}
        >
            <Button
                pattern="secondary"
                isInline={true}
                size={"small"}
                px={3}
                onClick={() => {
                    isNotUndefinedTypeGuard(data) &&
                        handleAddExtractionButtonClicked({
                            projectId: data.projectId,
                            databaseId: data.databaseId,
                            fileId: data.fileId,
                            fileName: data.parentFileName,
                        });
                }}
            >
                Add
            </Button>
            <Typography
                variant="body3"
                sx={{
                    color: "var(--text-color-disabled)",
                }}
            >
                Create a new extraction
            </Typography>
        </Box>
    );
};
